import { Box, Text } from "grommet";
import { forwardRef } from "react";
import { animated } from "react-spring";
import { TipQueueEntry } from "../types/TipQueue";

interface Props {
  entry: TipQueueEntry;
  isTipNotesOnly: boolean;
}

// One tip on the OBS widget. Read-only: the queue is worked from the Tip
// Queue page, and this mirrors it.
const RecentTipItem = forwardRef<any, Props>((props: Props, ref: any) => {
  const { entry, isTipNotesOnly } = props;
  const banked = entry.status === "banked";
  return (
    <animated.div key={entry.id} ref={ref}>
      <Box
        border={{ color: banked ? "accent-2" : "status-ok" }}
        direction="row"
        pad={"xxsmall"}
        width="small"
        gap="small"
        round="small"
      >
        <Box flex direction="column" gap="xsmall">
          <div className="flex flex-col gap-1 justify-start text-center text-sm">
            <div className="flex flex-row flex-wrap gap-2">
              <Text color="brand" size="xsmall">
                {entry.username}
              </Text>
              <Text color={banked ? "accent-2" : "status-ok"} size="xsmall">
                {entry.itemName}
              </Text>
            </div>
          </div>
          {isTipNotesOnly && entry.message.length > 0 ? (
            <Box background={"dark-1"} round={"xsmall"}>
              <Text size="xsmall">{entry.message}</Text>
            </Box>
          ) : null}
        </Box>
      </Box>
    </animated.div>
  );
});

export default RecentTipItem;
